import PropTypes from "prop-types"
const Spinner = ({ color = "white", height = "20px" }) => {
  return (
    <svg
      width={height}
      height={height}
      viewBox="0 0 50 50"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        strokeWidth="5"
        stroke={color}
        strokeLinecap="round"
        strokeDashoffset="0"
        strokeDasharray="95"
        className="spinner"
      />
    </svg>
  )
}

Spinner.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
}

export default Spinner
